import Style from "./style"
import StoreTicket from "./ui/StoreTicketRecord"

import MainHeader from "widget/MainHeader"

import useGetStoreManagerDetail from "entity/store/useGetStoreManagerDetail"

import DTStyle from "shared/style/detailTableStyle"
import timestampCalculator from "shared/lib/timestampCalculator"

const StoreManagerDetail = () => {

    const [storeManagerData] = useGetStoreManagerDetail()

    const storeManagerDataList = [
        {
            "label": "IDX",
            "value": storeManagerData?.data?.idx
        },
        {
            "label": "이름",
            "value": storeManagerData?.data?.name
        },
        {
            "label": "연락처",
            "value": storeManagerData?.data?.contact
        },
        {
            "label": "상태",
            "value": storeManagerData?.data?.is_approve ? "승인" : "미승인"
        },
        {
            "label": "가입 날짜",
            "value": timestampCalculator(storeManagerData?.data?.created_at)
        },
    ]

    const storeDataList = [
        {
            "label": "이름",
            "value": storeManagerData?.data?.store_name
        },
        {
            "label": "주소",
            "value": storeManagerData?.data?.store_address
        },

    ]

    return (
        <Style.Wrapper>
            <MainHeader />

            <Style.AreaDiv>
                <h2>매장 매니저 정보</h2>
                <DTStyle.TableDiv>
                    {storeManagerDataList?.map(elem =>
                        <DTStyle.TableElement>
                            <h2>{elem?.label}</h2>
                            <p>{elem?.value}</p>
                        </DTStyle.TableElement>
                    )}
                </DTStyle.TableDiv>
            </Style.AreaDiv>

            <Style.AreaDiv>
                <h2>매장 정보</h2>
                <DTStyle.TableDiv>
                    {storeDataList?.map(elem =>
                        <DTStyle.TableElement>
                            <h2>{elem?.label}</h2>
                            <p>{elem?.value}</p>
                        </DTStyle.TableElement>
                    )}
                </DTStyle.TableDiv>
            </Style.AreaDiv>

            <StoreTicket />

        </Style.Wrapper >
    )
}

export default StoreManagerDetail